import { H1, H3 } from "@datapay-by-datacom/design-system";
import { OrgList } from "../components/Org/OrgList";
import styles from "./OrgListScreen.module.css";

export function OrgListScreen() {
  return (
    <div className={styles.container}>
      <H1>Knowledge Bases</H1>

      <p>
        Agents can read and base their answers on any documents to which you
        have access via your organisations.
      </p>

      <H3>Your organisations</H3>

      <OrgList />
    </div>
  );
}
